<template>
  <div class="bg-white">
    <div
      class="testimonial-section testimonials rounded-[19px] p-5 sm:p-7.5 md:p-10 lg:p-12.5 container mx-auto bg-[url('@src/assets/images/HomePage/testimonial-bg.svg')] bg-no-repeat bg-center bg-cover"
    >
      <h3 class="text-center mb-5">Trusted by schools worldwide - Try It Today</h3>
      <div>
        <div
          class="flex flex-col w-full md:flex-row items-center gap-10 md:gap-5 lg:gap-14 xl:gap-20 1.5xl:gap-25"
        >
          <div class="h-full flex flex-col gap-5 md:flex-row items-center">
            <div class="w-full md:w-1/2 lg:px-8 1.5xl:px-10 2xl:px-12">
              <TouchWithUs id="demo" :hide-content-section="true" />
            </div>
            <div class="w-full md:w-1/2">
              <div>
                <Testimonial />
              </div>
              <div :key="forceRender" class="flex flex-row justify-center gap-8 mt-5">
                <div
                  class="custom-prev cursor-pointer w-4.5 h-4.5 rounded-full flex border-primary-purple-200 hover:border-primary-purple-400 hover:bg-primary-purple-400 border-2 justify-center items-center"
                  @click="prevSlide"
                ></div>
                <div
                  class="custom-next cursor-pointer hover:border-primary-purple-400 hover:bg-primary-purple-400 w-4.5 h-4.5 border-2 flex border-primary-purple-200 justify-center items-center rounded-full"
                  @click="nextSlide"
                ></div>
              </div>
              <div class="mx-auto flex justify-center items-center relative">
                <div
                  class="dummy-dot absolute cursor-pointer w-4.5 h-4.5 rounded-full border-primary-purple-400 bg-primary-purple-400 border-2 mb-5"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Testimonial from '@/src/views/landingPage/TestimonialCard.vue'
import { mapState } from 'vuex'
import TouchWithUs from '@src/views/home-page/TouchWithUs.vue'

export default {
  name: 'Testimonials',
  components: {
    Testimonial,
    TouchWithUs,
  },
  data() {
    return {
      forceRender: 1,
      landingPage: 'landingPage',
      testimonialsData: {
        heading: 'TESTIMONIALS',
        description: 'TESTIMONIALS_DESCRIPTION',
      },
    }
  },
  computed: {
    ...mapState(['currentSelectedLanguage']),
  },
  mounted() {
    this.initOwlCarousel()
  },
  beforeUnmount() {
    this.destroyOwlCarousel()
  },
  methods: {
    initOwlCarousel() {
      const options = {
        items: 1,
        autoplay: true,
        loop: true,
        margin: 10,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        nav: false,
        dots: true,
        dotClass: 'custom-dot',
        dotsClass: 'custom-dots',
      }
      $(this.$el.querySelector('.owl-carousel')).owlCarousel(options)
    },
    prevSlide() {
      $(this.$el.querySelector('.owl-carousel')).trigger('prev.owl.carousel')
    },
    nextSlide() {
      $(this.$el.querySelector('.owl-carousel')).trigger('next.owl.carousel')
    },
    destroyOwlCarousel() {
      $(this.$el.querySelector('.owl-carousel')).trigger('destroy.owl.carousel')
    },
  },
}
</script>

<style scoped>
.custom-dot {
  background-color: #8b5cf6;
  border-radius: 50%;
}
</style>